import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'modules';
import { ConsultingProgramAboutWrapper } from 'components/programAbout/ConsultingProgramAbout';
import { CWindowWidth } from 'constants/base.const';
import { Avatar, List, message, Col, Row, Typography, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { Colors } from 'GlobalStyles';
import IconBagSource from 'assets/icons/bag.svg';
import IconCheckSource from 'assets/icons/check2.svg';
import FacebookLogoSource from 'assets/icons/facebook.svg';
import AmazonLogoSource from 'assets/images/logos/amazon.svg';
import AppleLogoSource from 'assets/images/logos/apple.svg';
import GoogleLogoSource from 'assets/images/logos/google.svg';
import NetflixLogoSource from 'assets/images/logos/netflix.svg';
import TechProgramAboutSource1 from 'assets/images/pages/programAbout/finance_about_1.webp';
import TechProgramAboutSource2 from 'assets/images/pages/programAbout/finance_about_2.webp';
import TechProgramAboutSource3 from 'assets/images/pages/programAbout/finance_about_3.webp';
import 'animate.css/animate.min.css';

const { Text, Title } = Typography;
const maxWidth = CWindowWidth - 200;

const TechProgramAbout = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  function handleClickInquiry() {
    message.info('우측 하단 챗봇을 통해 상담을 진행해주세요.');
  }

  return (
    <ConsultingProgramAboutWrapper>
      <Helmet>
        <title>Tech - 프로그램 소개</title>
      </Helmet>
      <div className='title-mentoring'>
        <Row align='middle' style={{ height: '100%' }}>
          <Col xs={{ offset: 0 }} sm={{ offset: 0 }} md={{ offset: 2 }} lg={{ offset: 2 }} xl={{ offset: 2 }}>
            <Title>프로그램 소개</Title>
            <Text style={{ marginTop: '10px' }}>
              Global Tech Firm 입사를 위한
              <br />
              Career Step 만의 멘토링 프로그램
            </Text>
          </Col>
        </Row>
      </div>
      <div className='container' style={{ marginTop: '100px', marginBottom: '100px' }}>
        <div
          style={{
            padding: '0px 8px',
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#000',
            marginBottom: '70px',
          }}
        >
          Career Step Tech 멘토들의 전/현직 직장:
          <div style={{ maxWidth: '900px', margin: '40px auto' }}>
            <Row gutter={[32, 32]} justify='space-between' align='middle'>
              <Col>
                <img alt='AppleLogo' src={AppleLogoSource} className='company-logo' />
              </Col>
              <Col>
                <img alt='GoogleLogo' src={GoogleLogoSource} className='company-logo-wide' />
              </Col>
              <Col>
                <img alt='FacebookLogo' src={FacebookLogoSource} className='company-logo-wide' />
              </Col>
              <Col>
                <img alt='NetflixLogo' src={NetflixLogoSource} className='company-logo-wide' />
              </Col>
              <Col>
                <img alt='AmazonLogo' src={AmazonLogoSource} className='company-logo-wide' />
              </Col>
            </Row>
          </div>
        </div>
        <Title level={2} style={{ padding: '0px 8px' }}>
          Career Step 프로그램
        </Title>
        <div style={{ padding: '0px 8px', color: '#000', fontSize: '16px' }}>
          Career Step은 Global Tech Firm 조인을 위한 멘토 매칭 플랫폼을 운영 중입니다.
        </div>
        <div style={{ margin: '70px auto' }}>
          <Row align='middle' gutter={[64, 16]} justify='space-between' style={{ marginBottom: '40px' }}>
            <Col
              xs={{ span: 24, order: 2 }}
              sm={{ span: 24, order: 2 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 12, order: 1 }}
              xl={{ span: 12, order: 1 }}
            >
              <ScrollAnimation animateIn='fadeInLeft' animateOnce={true} duration={1.5}>
                <Avatar
                  shape='square'
                  src={TechProgramAboutSource1}
                  style={{ height: 'auto', width: '100%' }}
                />
              </ScrollAnimation>
            </Col>
            <Col
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 12, order: 2 }}
              lg={{ span: 12, order: 2 }}
              xl={{ span: 12, order: 2 }}
            >
              <p className='step-info step-right'>
                <Title level={2}>멘티 맞춤형 1:1 멘토링</Title>
                <List split={false}>
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='60분간 진행되는 1:1 비대면 멘토링'
                  />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='다양한 Global Top-tier Tech Firm의 전/현직자 Pool'
                  />
                </List>
                <Row justify='start' gutter={[16, 16]} style={{ marginTop: '20px' }}>
                  <Col span={10}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconBagSource} />
                      Global Tech Firm
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconBagSource} />
                      국내 IT 기업
                    </div>
                  </Col>
                  <Col span={10}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconBagSource} />
                      개발 직군
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconBagSource} />
                      BD, Sales & Marketing 직군
                    </div>
                  </Col>
                </Row>
              </p>
            </Col>
          </Row>
          <Row align='middle' gutter={[64, 16]} justify='space-between' style={{ marginBottom: '40px' }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <p className='step-info step-left'>
                <Title level={2}>자유로운 멘토링 주제 선정</Title>
                <List split={false}>
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='나에게 가장 필요한 토픽을 자유롭게 선택'
                  />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    description='Top-tier 멘토들에게 듣는 현실적인 조언부터 실무 Training까지'
                  />
                </List>
                <Row justify='start' gutter={[16, 16]} style={{ marginTop: '20px' }}>
                  <Col span={10}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconCheckSource} />
                      Resume
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconCheckSource} />
                      Essay Edit
                    </div>
                  </Col>
                  <Col span={10}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconCheckSource} />
                      Interview Preparation
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className='name-list'>
                      <img alt='Icon' src={IconCheckSource} />
                      Coding Test
                    </div>
                  </Col>
                </Row>
              </p>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <ScrollAnimation animateIn='fadeInRight' animateOnce={true} duration={1.5}>
                <Avatar
                  shape='square'
                  src={TechProgramAboutSource2}
                  style={{ height: 'auto', width: '100%' }}
                />
              </ScrollAnimation>
            </Col>
          </Row>
          <Row align='middle' gutter={[64, 16]} justify='space-between' style={{ marginBottom: '40px' }}>
            <Col
              xs={{ span: 24, order: 2 }}
              sm={{ span: 24, order: 2 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 12, order: 1 }}
              xl={{ span: 12, order: 1 }}
            >
              <ScrollAnimation animateIn='fadeInLeft' animateOnce={true} duration={1.5}>
                <Avatar
                  shape='square'
                  src={TechProgramAboutSource3}
                  style={{ height: 'auto', width: '100%' }}
                />
              </ScrollAnimation>
            </Col>
            <Col
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 12, order: 2 }}
              lg={{ span: 12, order: 2 }}
              xl={{ span: 12, order: 2 }}
            >
              <p className='step-info step-right'>
                <Title level={2}>Pricing</Title>
                <List split={false}>
                  <List.Item.Meta avatar={<CheckOutlined />} description='멘토링 신청 시 결제' />
                  <List.Item.Meta
                    avatar={<CheckOutlined />}
                    // description="시니어(인터뷰어 출신): 시간당 25만원"
                    description='1회권 25만원(시니어/주니어 무관)'
                  />
                  {/* <List.Item.Meta
                    avatar={<CheckOutlined/>}
                    // description="주니어: 시간당 15만원"
                    description="주니어: 1회 15만원(60분)"
                  /> */}
                </List>
              </p>
            </Col>
          </Row>
        </div>
      </div>

      <div className='container'>
        <p
          style={{
            color: `${Colors.grey2}`,
            marginLeft: '-20px',
            marginBottom: '-20px',
          }}
        >
          * 이용 가능 기간: 수강권 구매 후 1년
        </p>
      </div>
      <div className='apply-mentoring'>
        <div className='apply-mentoring-content'>
          <Title style={{ color: '#fff' }}>상담하기</Title>
          <p style={{ fontSize: 14, color: '#83979F', fontWeight: 'bold' }}>
            멘토링 신청 전 고민이 있으신가요?
          </p>
          <Button onClick={handleClickInquiry} style={{ backgroundColor: '#fff' }} size='large' shape='round'>
            <span style={{ color: '#2A4753', fontWeight: 'bold' }}>상담하기</span>
          </Button>
        </div>
      </div>
    </ConsultingProgramAboutWrapper>
  );
};

export default TechProgramAbout;
